// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Icon, Input, clsx } from '@a-type/ui';
import { Link } from '@verdant-web/react-router';
export function CopyTextbox(_a) {
    var { value, className, hideShare } = _a, rest = __rest(_a, ["value", "className", "hideShare"]);
    const isUrl = value.startsWith('http');
    const copy = () => {
        navigator.clipboard.writeText(value);
    };
    const share = () => {
        navigator.share(isUrl ? { url: value } : { text: value });
    };
    return (_jsxs(Box, Object.assign({ d: "row", gap: "sm", items: "center", className: clsx('w-full', className) }, rest, { children: [_jsx(Input, { disabled: true, value: value, className: "flex-[1_1_0]" }), _jsxs(Box, { d: "row", gap: "sm", children: [_jsx(Button, { size: "icon", onClick: copy, children: _jsx(Icon, { name: "copy" }) }), isUrl && (_jsx(Button, { size: "icon", asChild: true, children: _jsx(Link, { className: "color-inherit", newTab: true, to: value, children: _jsx(Icon, { name: "new_window" }) }) })), !hideShare && (_jsx(Button, { size: "icon", onClick: share, color: "primary", children: _jsx(Icon, { name: "share" }) }))] })] })));
}
//# sourceMappingURL=CopyTextbox.js.map